import { BASE_CORE_URL,BASE_CORE_URL_MISC,UAPI_URL_CONFIG } from "../config"

//#region Api Calling for GetDataAccess 
export const getDataAccess = async () => {
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        }
    }
    let url = UAPI_URL_CONFIG +"dag/getDAG?userId="+localStorage.getItem('UserID')+"&dataAccessGroupMasterId=1&organizationMasterId="+JSON.parse(localStorage.getItem('user')).OrganizationMasterID;

    return await fetch(url, requestOptions)
        .then(resp => resp.json())
        .then(data => {
            console.log(data);
            return data;
        })
        .catch(err => {
            console.log(err);
        })
}
//#endregion

//#region Api Calling for AddDataAccess
export const postDataAccess = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj),
    }
    let url = BASE_CORE_URL_MISC + "DataAccess/Add";
    return await fetch(url, requestOptions)
        .then(resp => resp.json())
        .then(data => {
            return data;
        })
        .catch(err => {
            console.log(err);
        })
}
//#endregion

//#region Api Calling for updateDataAccess
export const updateDataAccess = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj),
    }
    let url = BASE_CORE_URL_MISC + "DataAccess/Update";

    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch(err => {
            console.log(err);
        })
}
//#endregion

//#region Api Calling for Delete Data Access
export const deleteDataAccess = async (obj) => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj),
    }

    let url = BASE_CORE_URL_MISC + "DataAccess/Delete";

    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        }).catch(err => {
            console.log(err);
        })
}
//#endregion

//#region Api calling for GetMasterData 
export const getMasterData = async (obj) => {
    let { entity, fileName, parentId, childId, pageNumber, pageType, searchText } = obj;
    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
    }
    let url = BASE_CORE_URL_MISC + "DataAccess/GetMaster?userId=" + localStorage.getItem('UserID') + "&type=" + entity + "&fileName=" + fileName + "&parentId=" + parentId + "&childId=" + childId + "&pageNumber=" + pageNumber + "&pageType=" + pageType + "&searchText=" + searchText;
    console.log("CallAPI GetMasterData getMasterFunc", url);
    return await fetch(url, requestOptions)
        .then((res) => res.json())
        .then(data => {
            return data;
        })
        .catch(err => {
            console.log(err);
        })
}
//#endregion

//#region Api Calling for AddEnity
export const addEntity = async (obj) => {
    // let {entity, fileName, ids } = obj;
    console.log("Add Entity ", obj);
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj)
    }

    let url = BASE_CORE_URL_MISC + "DataAccess/AddEntity";

    return await fetch(url, requestOptions)
        .then((res) => res.json())
        .then((data) => {
            return data;
        })
        .catch(err => {
            console.log(err);
        })
}
//#endregion

//#region Api Calling for remove Entity
export const removeEntity = async (obj) => {
    let { entity, fileName, ids } = obj;

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken')
        },
        body: JSON.stringify(obj)
    }

    let url = BASE_CORE_URL_MISC + "DataAccess/RemoveEntity";

    return await fetch(url, requestOptions)
        .then((res) => res.json())
        .then((data) => {
            return data;
        })
        .catch(err => {
            console.log(err);
        })
}
//#endregion

//#region  Api Calling for GetDetails
export const getDetails = async (id, parentId, fname, pageNo, searchText, searchType) => {
    const requestOptions = {
        method: "GET",
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
    }

    let url = BASE_CORE_URL_MISC + `DataAccess/GetDetails?userId=${localStorage.getItem('UserID')}&childId=${id}&parentId=${parentId}&fileName=${fname}&pageNumber=${pageNo}&searchText=${searchText}&searchType=${searchType}`
    console.log("GetDetails CallAPI", url);
    return await fetch(url, requestOptions)
        .then((res) => res.json())
        .then((data) => {
            return data;
        })
        .catch(err => console.log(err));
}
//#endregion

//#region Api Calling for getReport(Export Data)
export const getReport = async (id, parentId, fname, searchText) => {
    const requestOptions = {
        method: 'GET',
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
    }

    let url = BASE_CORE_URL_MISC + `DataAccess/ExportData?userId=${localStorage.getItem('UserID')}&childId=${id}&parentId=${parentId}&fileName=${fname}&searchText=${searchText}`
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch((err) => console.log(err));
}
//#endregion

//#region Api calling for delete file
export const deleteFile = async (fileName) => {
    const requestOptions = {
        method: "GET",
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken')
    }

    let url = BASE_CORE_URL_MISC + `DataAccess/DeleteFile?fileName=${fileName}`
    return await fetch(url, requestOptions)
        .then(res => res.json())
        .then(data => {
            return data;
        })
        .catch((err) => console.log(err));
}
//#endregion